// extracted by mini-css-extract-plugin
module.exports =  {"icon-message":"_25d45facb5--icon-message--yMMzx","message-counter":"_25d45facb5--message-counter--y8ztx"};